/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLoqate = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20.538 15.245c0 .527-.005 1.053.003 1.58.002.137-.04.215-.16.286-2.746 1.61-5.49 3.224-8.233 4.84-.102.06-.18.07-.289.006-2.754-1.624-5.51-3.243-8.264-4.867-.06-.035-.128-.123-.128-.187-.007-1.053-.003-2.106-.002-3.158 0-.013.01-.025.023-.06.062.034.123.064.181.099 2.701 1.587 5.403 3.172 8.1 4.766.174.103.292.096.46-.003 2.692-1.59 5.389-3.173 8.085-4.757.059-.035.121-.066.224-.12z" />
        <path d="M11.82 2.059c.124-.073.216-.082.345-.006a3358 3358 0 0 0 8.214 4.828c.121.071.163.15.162.288a293.24 293.24 0 0 0 0 2.966c0 .137-.037.218-.16.29a3588.86 3588.86 0 0 0-8.233 4.838c-.117.069-.199.059-.308-.006a4711.92 4711.92 0 0 0-8.233-4.837c-.114-.067-.15-.143-.149-.272.007-.498.003-.996.003-1.493 0-.498.003-.997-.003-1.494-.002-.127.031-.205.147-.273 2.74-1.606 5.48-3.216 8.215-4.829zm.337 3.347c-.122-.073-.21-.064-.328.007-.83.494-1.664.98-2.497 1.47-.992.582-1.983 1.166-2.992 1.76.034.032.047.05.064.06 1.824 1.072 3.649 2.146 5.477 3.212.064.037.192.026.26-.013 1.43-.833 2.856-1.674 4.282-2.513l1.242-.731c-.052-.036-.08-.057-.11-.075-1.8-1.058-3.6-2.115-5.398-3.177z" />
      </g>
    </g>
  </Icon>
);
export { SvgLoqate as Loqate };
